import "./Loader.scss";
import { loaderMark } from "../../data/profileData";

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader-content">
        <h1 className="loader-logo">
          <img src={loaderMark} alt="Sameer" />
          
        </h1>
        <p className="loader-text">Sameer is thinking....</p>
        <div className="progress-bar-container">
          <div className="progress-bar"></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
